import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Grid, Button } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { ProfileType } from "../../types/enum";

import { ArtistIcon, AgentIcon, VenueIcon, PartiesIcon } from "./WelcomeIcons";

import production from "../../img/production.svg";
import dj from "../../img/dj.svg";

import "./ChooseProfile.css";

const SHOW_PRODUCTION_CREW = process.env.REACT_APP_SHOW_PRODUCTION_CREW === "true";
const SHOW_DJ = process.env.REACT_APP_SHOW_DJ === "true";

@inject("profileStore")
@withRouter
@observer
class ChooseProfile extends Component {
    handleRedirect = (route, profileType) => {
        this.props.profileStore.setProfileType(profileType);
        this.props.history.push(route);
    };
    componentDidMount() {
        var profile = this.props.profileStore.getCurrentProfile();
        if(profile){
            if(profile.type === ProfileType.Musician.ordinal){
                this.handleRedirect("/musician/edit/new", ProfileType.Musician.ordinal)
            }
            if(profile.type === ProfileType.Agent.ordinal){
                this.handleRedirect("/agent/edit/new", ProfileType.Agent.ordinal)
            }
            if(profile.type === ProfileType.Staff.ordinal){
                this.handleRedirect("/staff/edit/new", ProfileType.Staff.ordinal)
            }
           
        }
    }

    render() {
        const type = this.props.type;

        return (
            <div className="profile-picker-container">
                {type !== "venue" && (
                    <div 
                        className="profile-card"
                        onClick={() => this.handleRedirect("/musician/edit/new", ProfileType.Musician.ordinal)}
                        id="create-musician-profile"
                    >
                        <div className="profile-card-icon">
                            <ArtistIcon />
                        </div>
                        <div className="profile-card-title">Artist / Entertainer</div>
                        <div className="profile-card-description">
                            Performers, musicians, DJs, and entertainers
                        </div>
                    </div>
                )}

                {type !== "musician" && type !== "venue" && (
                    <div 
                        className="profile-card"
                        onClick={() => this.handleRedirect("/agent/edit/new", ProfileType.Agent.ordinal)}
                        id="create-agent-profile"
                    >
                        <div className="profile-card-icon">
                            <AgentIcon />
                        </div>
                        <div className="profile-card-title">Agent</div>
                        <div className="profile-card-description">
                            Manage and book talent for venues
                        </div>
                    </div>
                )}

                {type !== "musician" && (
                    <div 
                        className="profile-card"
                        onClick={() => this.handleRedirect("/staff/edit/new", ProfileType.Staff.ordinal)}
                        id="create-staff-profile"
                    >
                        <div className="profile-card-icon">
                            <VenueIcon />
                        </div>
                        <div className="profile-card-title">Venue</div>
                        <div className="profile-card-description">
                            Pubs, clubs, restaurants, and event spaces
                        </div>
                    </div>
                )}

                {type !== "musician" && type !== "venue" && (
                    <div 
                        className="profile-card"
                        onClick={() => this.handleRedirect("/privatehire/edit/new", ProfileType.PrivateHire.ordinal)}
                        id="create-private-hire"
                    >
                        <div className="profile-card-icon">
                            <PartiesIcon />
                        </div>
                        <div className="profile-card-title">Parties & Events</div>
                        <div className="profile-card-description">
                            Private event organisers and party planners
                        </div>
                    </div>
                )}

                {type !== "venue" && SHOW_PRODUCTION_CREW && (
                    <div 
                        className="profile-card"
                        onClick={() => this.handleRedirect("/production/edit/new", ProfileType.Production.ordinal)}
                        id="create-production-profile"
                    >
                        <div className="profile-card-icon">
                            <img src={production} alt="production" />
                        </div>
                        <div className="profile-card-title">Production</div>
                        <div className="profile-card-description">
                            Production crew and technical staff
                        </div>
                    </div>
                )}

                {type !== "venue" && SHOW_DJ && (
                    <div 
                        className="profile-card"
                        onClick={() => this.handleRedirect("/dj/edit/new", ProfileType.Dj.ordinal)}
                        id="create-dj-profile"
                    >
                        <div className="profile-card-icon">
                            <img src={dj} alt="dj" />
                        </div>
                        <div className="profile-card-title">DJ</div>
                        <div className="profile-card-description">
                            Disc jockeys and music selectors
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ChooseProfile;
